import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const scrollToId = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });

export const AnchorLink = ({ hash, className, onClick, children, ...rest }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const go = (e) => {
    e.preventDefault();
    onClick?.();
    if (pathname === '/') {
      scrollToId(hash);
    } else {
      navigate(`/#${hash}`);
    }
  };

  return (
    <a href={`/#${hash}`} className={className} onClick={go} {...rest}>
      {children}
    </a>
  );
};

export const useScrollToHash = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 150);
    return () => clearTimeout(t);
  }, [hash]);
};
